import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { RISK_ASSESSMENT_GAUGE_PALETTE_MAX_5, RiskAssessmentChart } from '@pt/pt-models';
import { RiskEvaluationGroup } from 'it/primatoo/openapi/api/org/schemas/treatment/riskassessment/RiskEvaluationGroup';
import { StatsChartBuilder } from '../../utils';

/**
 * ATTENZIONE: questo componente è usato anche all'interno dell'editor della DPIA,
 * Li il suo funzionamento è corretto, se utilizzato altrove o clonarlo o evitare di modificare il comportamento nell'editor
 * nota di @giovanni
 */
@Component({
  selector: 'pt-risk-assessment-stats',
  template: `

    <ng-template *ngIf='riskAssessmentStats.length > 0; then statsAvailable; else noStatsAvailable'></ng-template>

    <ng-template #statsAvailable>
      <ng-container [ngSwitch]='mode'>
        <ng-container *ngSwitchCase='"select"'>
          <div class="dt-title-container">
            <div class="dt-title" *ngIf="title">{{ title }}</div>
          </div>
          <div class="stat-detail-container">
            <ng-select class="pt-select--custom"
                       [clearable]="false"
                       [(ngModel)]="activeRiskAss"
                       (click)="$event.stopPropagation();">
              <ng-container *ngFor="let item of riskAssessmentStats">
                <ng-option [value]="item">
                  {{ item.label }}
                </ng-option>
              </ng-container>
            </ng-select>

            <pt-details-chart
              [title]='null'
              [charts]='activeRiskAss?.charts'
              [gaugeColor]='riskAssessmentGaugeColor'>
            </pt-details-chart>
          </div>
        </ng-container>


        <ng-container *ngSwitchCase='"tab"'>
          <div class="dt-title" *ngIf="title">{{ title }}</div>
          <ul ngbNav #nav='ngbNav' [(activeId)]='activeChartsTab' class='nav-tabs nav-fill nav-pills'>
            <li [ngbNavItem]='i'
                *ngFor='let chart of riskAssessmentStats; index as i'>
              <a ngbNavLink class="d-flex text-start justify-content-between">
                {{ chart.label }}
                <div class='pt-btn-reload-flat'
                     [ngbTooltip]="'BUTTON.RECALCULATE' | translate"
                     *ngIf="showReload" (click)="reloadStats.emit()">
                  <pt-icon [key]="'refresh-outline'"></pt-icon>
                </div>
              </a>
              <ng-template ngbNavContent>
                <pt-details-chart
                  [title]='null'
                  [charts]='chart.charts'
                  [gaugeColor]='riskAssessmentGaugeColor'>
                </pt-details-chart>
              </ng-template>
            </li>
          </ul>

          <div [ngbNavOutlet]='nav' class='mt-2'></div>

        </ng-container>

        <ng-container *ngSwitchCase='"list"'>
          <div class="dt-title" *ngIf="title">{{ title }}</div>
          <div *ngFor='let chart of riskAssessmentStats; index as i'>
            <a class="d-flex">
              {{ chart.label }}
              <div class='pt-btn-reload-flat'
                   [ngbTooltip]="'BUTTON.RECALCULATE' | translate"
                   (click)="reloadStats.emit()">
                <pt-icon [key]="'refresh-outline'"></pt-icon>
              </div>
            </a>
            <pt-details-chart
              [title]='null'
              [gaugeColor]='riskAssessmentGaugeColor'
              [charts]='chart.charts'>
            </pt-details-chart>
          </div>

        </ng-container>

      </ng-container>
    </ng-template>

    <ng-template #noStatsAvailable>
      <div class="stat-no-data">
        <div class="dt-title" *ngIf="title">{{ title }}</div>
        <pt-no-available-stats></pt-no-available-stats>
      </div>
    </ng-template>
  `,
  styles: [`
    .stat-detail-container {
      width: calc(100% - 30px);
      /*max-width: 375px;*/
    }
    .stat-no-data {
      height: 70px;
      width: 100%;
    }
    .dt-title-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 10px;
    }
    .dt-title {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      font-size: 15px;
      font-weight: bold;
    }
  `]
})
export class RiskAssessmentStatsComponent implements OnChanges {

  @Input() title?: string;
  @Input() evaluation: Array<RiskEvaluationGroup>;
  @Input() mode: 'list' | 'tab' | 'select' = 'tab';
  @Input() showReload = false;
  @Output() reloadStats: EventEmitter<boolean> = new EventEmitter<boolean>();

  riskAssessmentStats: RiskAssessmentChart[];
  activeRiskAss: RiskAssessmentChart;
  show: boolean;
  activeChartsTab = 0;
  riskAssessmentGaugeColor = RISK_ASSESSMENT_GAUGE_PALETTE_MAX_5;

  ngOnChanges(): void {
    this.show = false;
    this.riskAssessmentStats = [];
    if (this.evaluation?.length > 0) {
      this.riskAssessmentStats = StatsChartBuilder.buildRiskAssessmentStatsV2(this.evaluation);
      this.activeRiskAss = this.riskAssessmentStats?.length > 0 ? this.riskAssessmentStats[0] : undefined;
    }
    setTimeout(() => this.show = true);
  }

  changeActiveRiskAss(activeRiskAss: RiskAssessmentChart) {
    this.activeRiskAss = activeRiskAss;
  }
}
